import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 24px 24px;
  height: 100%;
  max-height: 621px;
`;

export const Title = styled.h1`
  flex: 1;
  font-style: normal;
  white-space: nowrap;
  font-weight: normal;
  font-size: 18px;
  font-weight: 600;
  align-items: center;
  display: flex;
  margin: 0;
  flex-direction: row;
  color: ${beam.font.primary};
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Close = styled.button`
  cursor: pointer;
  font-size: 14px;
  margin-right: 20px;
  border: none;
  background: transparent;
`;

export const Product = styled.div`
  background: #f8faff;
  border-radius: 8px;
  padding: 16px 12px;
  display: flex;
  align-items: center;
`;

export const ProductImage = styled.img`
  background: #ffffff;
  border: 1px solid #e6e8f0;
  border-radius: 4px;
  height: 45px;
  width: 45px;
`;

export const ProductRight = styled.div`
  margin-left: 10px;
`;

export const ProductTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  color: #1b203a;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const ProductModel = styled.div`
  font-weight: 400;
  font-size: 12px;
  color: #4b5067;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const SectionTitle = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: #474d66;
`;

export const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 12px;
`;

export const InfoRight = styled.div`
  margin-left: 8px;
  height: 20px;
`;

interface ICheckbox {
  checked: boolean;
}

export const Checkbox = styled.button<ICheckbox>`
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 1px solid ${({ checked }) => (checked ? '#1371fe' : '#d8dae5')};
  background-color: ${({ checked }) => (checked ? '#1371fe' : '#fff')};
`;

export const ItemsList = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 8px;
  margin-top: 15px;
`;

export const ItemRow = styled.div`
  display: flex;
  align-items: center;
`;

export const ItemName = styled.div`
  margin-left: 12px;
  font-weight: 500;
  font-size: 14px;
  color: #474d66;
`;

export const Line = styled.div`
  width: 100%;
  background: #e6e8f0;
  height: 1px;
  margin-top: 23px;
`;

export const Label = styled.div`
  font-weight: 500;
  font-size: 12px;
  color: #474d66;

  &.optional {
    color: #8f95b2;
  }
`;

export const Input = styled.input`
  padding: 10px 16px;
  background: #ffffff;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  color: #474d66;
  font-weight: 400;
  font-size: 14px;
  width: 100%;

  ::placeholder {
    color: #8f95b2;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 24px;
  padding-top: 5px;
  bottom: 0;
  position: sticky;
  background-color: #fff;
  z-index: 12;
`;

export const Button = styled.button`
  background: ${({ disabled }) => (disabled ? '#EDEFF4' : '#1371FE')};
  border-radius: 8px;
  padding: 10px 16px;
  border: none;
  color: ${({ disabled }) => (disabled ? '#C1C4D6' : '#fff')};
  font-weight: 500;
  font-size: 14px;
`;

export const HelpToolTipTextDiv = styled.div`
  text-align: center;
  font-size: 12px;
  font-weight: 400;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const InputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const OverflowDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 5px;
  overflow-y: auto;
  overflow-x: hidden;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
    position: fixed;
    background-color: #fff;
    border-radius: 0 8px 8px 0;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: #fff;
  }
`;
